import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';

export class SmartsheetWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.smartsheet.ID;
        this.name = DatabaseEnum.smartsheet.NAME;
        this.code = DatabaseEnum.smartsheet.CODE;
        this.equivalentTag = DatabaseEnum.smartsheet.EQUIVALENT_TAG;
        this.showLoadPropertiesTab = true;
        this.showExtractPropertiesTab = true;
        this.showDatabaseTab = false;
        this.isFileType = false;
        this.disableTestDataPointButton = false;
        this.showViewDataTabOption = true;
        this.showDataObjectPropertiesTab = true;
        this.showDataDescription = false;
        this.isShowObjProperties = true;
        this.initializeSmartsheetProperties();
    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {
        if (String(repConnWrapper.repConn.conn.batchSize) == 'null' ||
            String(repConnWrapper.repConn.conn.batchSize) == '') {
            repConnWrapper.inValid_Cds.push('ESM00671');
        } else if (String(repConnWrapper.repConn.conn.timeOut) == 'null' ||
            String(repConnWrapper.repConn.conn.timeOut) == '') {
            repConnWrapper.inValid_Cds.push('ESM00672');
        }

        if (repConnWrapper.repConn.conn.access_Token_Flg == 'Y') {
            if (repConnWrapper.repConn.conn.consumerKey == "") {
                repConnWrapper.inValid_Cds.push('CONS_KEY');
            }

            if (repConnWrapper.repConn.conn.consumerSecret == "") {
                repConnWrapper.inValid_Cds.push('CONS_SEC');
            }

        }
        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }
    }

    initializeSmartsheetProperties(): void {
        this.showFileTypeGroup = false;
        this.showDelimiter = false;
        this.showFixedWidth = false;
    }

    readFileCutOffLength(type: string): number {
        return -1;
    }

    getConnectionString(repConnWrapper: RepConnWrapper): string {
        let connectionString = `jdbc:smartsheet:`;

        if (repConnWrapper.repConn.conn.access_Token_Flg == 'Y') {
            connectionString += `OAuthClientId=${repConnWrapper.repConn.conn.consumerKey};`;
            connectionString += `OAuthClientSecret=${repConnWrapper.repConn.conn.consumerSecret};`;
        } else {
            connectionString += `AccessToken=${repConnWrapper.repConn.conn.accessToken};`;
        }

        connectionString += `BatchSize=${repConnWrapper.repConn.conn.batchSize || 1000};`;
        connectionString += `Timeout=${repConnWrapper.repConn.conn.timeOut || 30};`;
        connectionString += `InitiateOAuth=GETANDREFRESH;`;

        if (repConnWrapper.repConn.conn.jdbcOptions) {
            connectionString += repConnWrapper.repConn.conn.jdbcOptions;
        }

        return connectionString;
    }
}
